import CrossIcon from '@assets/icons/cross.svg?react'
import cn from 'classnames'
import {
  isOwnerOrAdministrator,
  MerchantEntityTypes,
  selectCurrentUserRole,
  selectMerchantEntityType,
  useAppSelector
} from 'mmfintech-backend-api'
import { GlobalContext, tr, useDropDownMenu, useOutsideClick } from 'mmfintech-commons'
import type React from 'react'
import { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { usePaymentButtons } from './usePaymentButtons'

export const PaymentButtons = ({ rowHeight }) => {
  const { modalShow } = useContext(GlobalContext)

  const history = useHistory()
  const customerRole = useAppSelector(selectCurrentUserRole)
  const entityType = useAppSelector(selectMerchantEntityType)

  const { visible, toggleDropDown, hideDropDown } = useDropDownMenu()

  const ref = useOutsideClick(() => {
    hideDropDown()
  })

  const buttons = usePaymentButtons(isOwnerOrAdministrator(customerRole), entityType === MerchantEntityTypes.COMPANY)

  const handleClick = (e: React.BaseSyntheticEvent) => {
    e.stopPropagation()
    toggleDropDown()
  }

  return (
    <div onClick={handleClick} className={cn('header-payment-buttons', { visible })} ref={ref}>
      <span>{tr('FRONTEND.HEADER.QUICK_ACTIONS', 'Quick actions')}</span>
      <div className='payment-icon'>
        <CrossIcon />
      </div>

      <div
        className='payment-dropdown'
        style={{
          height: `${visible ? buttons.length * rowHeight + 53 : 0}px`
        }}
      >
        {buttons.map(button => {
          return (
            <div
              key={button.label}
              onClick={() => (button.path ? history.push(button.path) : button.func(modalShow))}
              className={cn('payment-button', { visible })}
            >
              {button.icon}
              <p>{button.label}</p>
            </div>
          )
        })}
      </div>
    </div>
  )
}
